import BasicGauge from './BasicGauge.json';
import LargeNumbersGauge from './LargeNumbersGauge.json';
import NoThresholdsGauge from './NoThresholdsGauge.json';
import NoThresholdsTargeValueGauge from './NoThresholdsTargeValueGauge.json';

export default [BasicGauge, LargeNumbersGauge, NoThresholdsGauge, NoThresholdsTargeValueGauge];
